var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import BaseDrawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/system';
import { useTheme } from '@mui/material';
import { DrawerTabs } from './components';
import Close from '@mui/icons-material/Close';
import { colorPalette } from '../../colorPalette';
import { Typography } from '../Typography';
export const Drawer = (_a) => {
    var { open, anchor, onClose, content, belowTabContent, tabs, tabsProps, drawerSize = 'sm', selectedTab, onChangeTab, PaperProps: paperProp = {}, showHeader = true, title, subTitle, footer } = _a, rest = __rest(_a, ["open", "anchor", "onClose", "content", "belowTabContent", "tabs", "tabsProps", "drawerSize", "selectedTab", "onChangeTab", "PaperProps", "showHeader", "title", "subTitle", "footer"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const defaultAnchor = isMobile ? 'bottom' : 'right';
    const width = drawerSize === 'sm' ? '380px' : drawerSize === 'lg' ? '680px' : '500px';
    const paperStyles = Object.assign({ width: { md: width }, maxHeight: { xs: `calc(100vh - 16px)`, md: '100vh' }, height: '100vh', borderTopRightRadius: { xs: '16px', md: 0 }, borderTopLeftRadius: { xs: '16px', md: 0 }, scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none' }, paperProp.sx);
    const footerStyles = {
        backgroundColor: 'white',
        position: 'fixed',
        bottom: 0,
        width: {
            xs: '100%',
            md: width,
        },
        height: '80px',
        padding: '16px',
        borderTop: `1px solid ${colorPalette.gray200}`,
    };
    return (React.createElement(BaseDrawer, Object.assign({}, rest, { anchor: defaultAnchor || anchor, container: () => {
            const id = 'hypernova-class-wrapper';
            let hpernovaClassWrapper = document.getElementById(id);
            if (!hpernovaClassWrapper) {
                hpernovaClassWrapper = document.createElement('div');
                hpernovaClassWrapper.classList.add('_hy');
                hpernovaClassWrapper.id = id;
                document.body.appendChild(hpernovaClassWrapper);
            }
            return hpernovaClassWrapper;
        }, PaperProps: Object.assign({ dataqa: 'drawer-paper', sx: paperStyles }, paperProp), onClose: onClose, open: open }),
        React.createElement(Stack, { sx: {
                position: 'relative',
            } },
            React.createElement(Stack, { sx: {
                    paddingBottom: footer ? '80px' : 0,
                } },
                showHeader && (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        height: {
                            xs: '56px',
                            lg: '72px',
                        },
                        padding: {
                            xs: '16px',
                            lg: '16px 24px',
                        },
                        borderBottom: `1px solid ${colorPalette.gray200}`,
                        zIndex: 999,
                    } },
                    React.createElement(Stack, { direction: "row", spacing: 1, alignItems: 'center' },
                        React.createElement(Typography, { variant: "h3-semibold", sx: {
                                color: colorPalette.gray800,
                            } }, title),
                        subTitle && (React.createElement(Typography, { variant: "h4-regular", sx: {
                                color: colorPalette.gray600,
                                paddingTop: '3px',
                            } }, subTitle))),
                    React.createElement(Box, { component: "div", sx: {
                            cursor: 'pointer',
                            padding: '8px',
                        }, onClick: onClose },
                        React.createElement(Close, { width: "24", height: "24", sx: {
                                color: colorPalette.gray700,
                            } })))),
                content,
                tabs && (React.createElement(DrawerTabs, Object.assign({ showHeader: showHeader || false, tabs: tabs, selectedTab: selectedTab, onChangeTab: onChangeTab }, tabsProps))),
                belowTabContent && React.createElement(Box, null, belowTabContent)),
            footer && (React.createElement(Stack, { sx: footerStyles, alignItems: "center", justifyContent: "center", flexDirection: "row", gap: 2 }, footer)))));
};
